import "./LeftNavBarComp.css";
import { defineComponent as N, resolveComponent as _, openBlock as t, createElementBlock as r, createElementVNode as i, createVNode as d, withCtx as a, Fragment as p, renderList as B, createBlock as l, normalizeClass as v, createCommentVNode as c, toDisplayString as f, withDirectives as C, vShow as m, renderSlot as w } from "vue";
import { ButtonComp as g } from "./ButtonComp.js";
import { IconComp as O } from "./IconComp.js";
import { OverflowComp as S } from "./OverflowComp.js";
import { _ as x } from "./_plugin-vue_export-helper.dad06003.js";
const $ = N({
  events: {
    itemClick: {
      type: Object,
      note: "Emits the object back which has been clicked. For Router links no action needed on parent side"
    }
  },
  components: {
    ButtonComp: g,
    IconComp: O,
    OverflowComp: S
  },
  props: {
    dropdownElements: {
      type: Array,
      required: !0
    }
  },
  methods: {
    buttonClasses(o = !1, k = !1) {
      return {
        leftNavBar__button: !0,
        "leftNavBar__button--spacer": o,
        "leftNavBar__button--newQuoteIcon": k
      };
    },
    handleClick(o) {
      o.to || (this.$emit("itemClick", o), o.callbackFn && o.callbackFn());
    },
    hasSlot(o) {
      return !!this.$slots[o];
    }
  }
});
const L = { class: "leftNavBar" }, D = { class: "leftNavBar__content" }, E = { class: "leftNavBar__expandedText" }, I = { class: "leftNavBar__expandedText" }, P = { class: "leftNavBar__expandedText" }, z = {
  key: 0,
  class: "leftNavBar__hideOnMinimize"
}, F = {
  key: 0,
  class: "leftNavBar__guestOverlay"
};
function T(o, k, V, j, G, Q) {
  const s = _("icon-comp"), b = _("router-link"), u = _("button-comp"), y = _("overflow-comp");
  return t(), r("div", L, [
    i("nav", D, [
      d(b, {
        class: "leftNavBar__logoLink",
        id: "logoLink",
        to: "/",
        alt: "Protolabs",
        "aria-label": "Protolabs Home"
      }, {
        default: a(() => [
          d(s, {
            class: "leftNavBar__fullLogo",
            icon: "logo-white-horizontal",
            width: "180px",
            alt: "Protolabs"
          }),
          d(s, {
            class: "leftNavBar__minimizedLogo",
            icon: "logo-white",
            height: "41px",
            width: "40px",
            alt: "Protolabs"
          })
        ]),
        _: 1
      }),
      (t(!0), r(p, null, B(o.dropdownElements, (e) => (t(), r(p, { key: e }, [
        e.overflowOptions && e.overflowOptions.length > 0 ? (t(), l(y, {
          key: 0,
          class: "leftNavBar__overflow",
          locked: "",
          gray: "",
          arrow: "",
          placement: e.overflowPlacement,
          offsetDistance: e.overflowOffsetDistance,
          offsetSkid: e.overflowOffsetSkid,
          disableIconRotation: ""
        }, {
          button: a(() => [
            d(u, {
              "t-sel": e.tSel,
              class: v([o.buttonClasses(e.borderBottom), "leftNavBar__button"])
            }, {
              default: a(() => [
                e.icon ? (t(), l(s, {
                  key: 0,
                  icon: e.icon
                }, null, 8, ["icon"])) : c("", !0),
                i("p", E, f(e.text), 1)
              ]),
              _: 2
            }, 1032, ["t-sel", "class"])
          ]),
          content: a(({ close: h }) => [
            (t(!0), r(p, null, B(e.overflowOptions, (n) => C((t(), l(u, {
              key: JSON.stringify(n),
              navGray: "",
              "t-sel": n.tSel,
              to: n.to,
              routerLink: "",
              onClick: (R) => h()
            }, {
              default: a(() => [
                n.icon ? (t(), l(s, {
                  key: 0,
                  icon: n.icon
                }, null, 8, ["icon"])) : c("", !0),
                i("p", null, f(n.text), 1)
              ]),
              _: 2
            }, 1032, ["t-sel", "to", "onClick"])), [
              [m, n.show]
            ])), 128))
          ]),
          _: 2
        }, 1032, ["placement", "offsetDistance", "offsetSkid"])) : e.to ? (t(), l(b, {
          key: 1,
          class: v(["leftNavBar__button", o.buttonClasses(e.borderBottom)]),
          to: e.to,
          "t-sel": e.tSel,
          id: e.id,
          target: e.target,
          "aria-label": e.text
        }, {
          default: a(() => [
            e.icon ? (t(), l(s, {
              key: 0,
              icon: e.icon
            }, null, 8, ["icon"])) : c("", !0),
            i("p", I, f(e.text), 1)
          ]),
          _: 2
        }, 1032, ["class", "to", "t-sel", "id", "target", "aria-label"])) : (t(), l(u, {
          key: 2,
          class: v(o.buttonClasses(e.borderBottom, e.isNewQuoteIcon)),
          onClick: (h) => o.handleClick(e),
          "t-sel": e.tSel,
          id: e.id,
          "aria-label": e.text,
          navGray: ""
        }, {
          default: a(() => [
            e.icon ? (t(), l(s, {
              key: 0,
              icon: e.icon
            }, null, 8, ["icon"])) : c("", !0),
            i("p", P, f(e.text), 1)
          ]),
          _: 2
        }, 1032, ["class", "onClick", "t-sel", "id", "aria-label"]))
      ], 64))), 128)),
      o.hasSlot("expandedOptions") ? (t(), r("div", z, [
        w(o.$slots, "expandedOptions", {}, void 0, !0)
      ])) : c("", !0)
    ]),
    o.hasSlot("guestOverlay") ? (t(), r("div", F, [
      w(o.$slots, "guestOverlay", {}, void 0, !0)
    ])) : c("", !0)
  ]);
}
const U = /* @__PURE__ */ x($, [["render", T], ["__scopeId", "data-v-5517ebff"]]);
export {
  U as LeftNavBarComp
};
//# sourceMappingURL=LeftNavBarComp.js.map
